import React from 'react';
import './style.css';

function Loading() {
  return (
    <div className="loader">
      <h1>Loading</h1>
    </div>
  );
}

export default Loading;